<template>
  <div class="btn_tag mr-1"
       :class="{ 'tag1': borderColor === 'yellow',
                 'tag2': borderColor === 'green',
                 'tag3': borderColor === 'blue',
                 'tag4': borderColor === 'green1',
                 'tag5': borderColor === 'blue1', }">{{ label }}</div>
</template>

<script>
export default {
  name: "SubjectBadge",
  props: {
    label: String,
    borderColor: {
      type: String,
      default: 'yellow'
    },
  }
}
</script>

<style scoped lang="scss">
.btn_tag {
  margin-right: 2px;
  padding: 2px 6px;
  display: flex;
  border-radius: 13px;
  background-color: white;
  font-size: $font-base10;
  font-weight: $font-weight700;
  color: $primary-color;
  border: 1px solid $primary-color;
}

.tag1 {
  color: $primary-color;
  border-color: $primary-color;
}

.tag2 {
  color: $sixth-color;
  border-color: $sixth-color;
}

.tag3 {
  color: $font-fifth-color;
  border-color: $font-fifth-color;
}

.tag4 {
  color: #13b5b1;
  border: 1px solid #13b5b1;
}

.tag5 {
  color: #1d7ced;
  border: 1px solid #1d7ced;
}

</style>